const fixMiniCart = () => {
    const ocuCartDrawer = document.querySelector(".ocu-cart-drawer");
    const lineItems = ocuCartDrawer.querySelectorAll(".ocu-cart-line-item-wrapper");
    if (lineItems.length) {
     lineItems.forEach((lineItem)=>{
       const itemKey = lineItem.getAttribute("data-key");
       const lineItemPrice = lineItem.querySelector(".ocu-cart-line-price-container")
       lineItem.setAttribute("bss-b2b-cart-item-key", itemKey);
       lineItemPrice.setAttribute("bss-b2b-final-line-price", "");
     }) 
    }
    ocuCartDrawer.classList.add("bss-b2b-mini-cart");
    const cartTotalPrice = ocuCartDrawer.querySelector(".ocu-cart-footer .ocu-estimated-info > div:nth-child(2)");
    if (cartTotalPrice) {
      cartTotalPrice.setAttribute("bss-b2b-cart-total-price", "");
    }
    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate')
}

const fixCheckoutBtn =() =>{
  const button = document.querySelector(".ocu-checkout-button");
  if (button) {
    const div = document.createElement("div");
    div.className = "btn btn-checkout";
    div.style.pointerEvents = "unset";
    div.style.cursor = "pointer";
    div.style.display = "flex";
    div.style.justifyContent = "center";
    div.style.alignItems = "center";
    div.style.height = "42px";
    div.style.background = "black";
    div.innerHTML = button.innerHTML;
    button.replaceWith(div);
  }
  BSS_B2B.observer.cartSubject.listenCartCheckout()
}
const showDcMiniCart = ()=>{
  
}
window.addEventListener("ocu:cart:updated", function(event) {
    fixMiniCart();
    fixCheckoutBtn();
});
window.addEventListener("ocu:cart:opened", function(event) {
    const miniCartFooter = document.querySelector(".ocu-cart-footer.drawer__footer.ocu-cart-sticky-footer");
    const dcMiniCart = document.querySelector(".dc-container");
    const shippingOption = document.querySelector(".shipping-option");
    if (miniCartFooter && dcMiniCart) {
       dcMiniCart.style.display = "block"
       miniCartFooter.parentNode.insertBefore(dcMiniCart, miniCartFooter);
    }
    if (miniCartFooter && shippingOption) {
      shippingOption.style.display = "block"
      miniCartFooter.parentNode.insertBefore(shippingOption, miniCartFooter);
    }
});

document.addEventListener("DOMContentLoaded", (event) => {
     if (BSS_B2B && document.querySelector(".delivery-method")) {
       let deliveryMethod = localStorage.getItem("delivery_method")
       if (deliveryMethod) {
         BSS_B2B.sr.status = JSON.parse(deliveryMethod)
       }
       const srStatus = BSS_B2B.sr.status
       if (srStatus) {
         document.querySelector(".delivery-method .pickup").removeAttribute("checked")
         document.querySelector(".delivery-method .shipping").setAttribute("checked", true)
       } else {
         document.querySelector(".delivery-method .shipping").removeAttribute("checked")
         document.querySelector(".delivery-method .pickup").setAttribute("checked", true)
       }
       document.querySelectorAll('input[name="deliveryOption"]').forEach(radio => {
          radio.addEventListener('change', function() {
              BSS_B2B.sr.status = this.value === "shipping";
              localStorage.setItem("delivery_method", JSON.stringify(BSS_B2B.sr.status))
          });
       });
     }
  });